module.exports = __webpack_public_path__ + "static/media/Accademia - Orange_White.7058ed79.jpg";